<template>
    <div>
        <div class="social-buttons">{{$t('share')}}</div>
        <social-sharing :url="currentUrl"
                      title="Bedaya"
                      :description="facebookText"
                      :quote="facebookText"
                      :hashtags="hashtags"
                      inline-template>
          <network network="facebook" class="share share-fb">
          </network>
        </social-sharing>
        <social-sharing :url="currentUrl"
                      :title="twitterText"
                      :description="twitterText"
                      :hashtags="hashtags"
                      twitter-user="IRC_KHF @data4change"
                      inline-template>
          <network network="twitter" class="share share-twitter">
          </network>
        </social-sharing>
    </div>
</template>

<script>
  export default {
    name: "share-buttons",
    computed: {
      currentUrl () {
        return window.location.origin + window.location.pathname
      },
      hashtags () {
        if (this.$i18n.locale == 'ar'){
          return 'بداية ,أيتام , فاقدي_السند_الأسري '
        }
        return 'Bedaya, orphans, YDFT'
      },
      facebookText () {
        return this.$i18n.t('social.facebook')
      },
      twitterText () {
        return this.$i18n.t('social.twitter')
      }
    }
  }
</script>

<style lang="stylus">
.social-buttons
  margin-top 15px
  margin-bottom 5px
  font-weight 700
.share
  display inline-block
  border-radius 5px
  background-color #EFEFEF
  height 33px
  width 66px
  background-position center
  background-repeat no-repeat
  cursor pointer
  &.share-fb
    background-image url('~@/../static/icons/facebook.png')
  &.share-twitter
    background-image url('~@/../static/icons/twitter.png')

</style>


// WEBPACK FOOTER //
// src/components/ShareButtons.vue